import { entityId } from "./types";
import { BookingInterestSessionInterface, SessionInterface } from "./Session";
import { ShowInterface } from "./Show";
import { IRelatedBookingInterestUpdate } from "./BookingTicket";
import { TicketInterface } from "./Ticket";
import { BookingInterestStatus } from "../../enums/BookingInterestStatus"
import { AllocationType } from "./AllocationV2";
export interface BookingInterestInterface {
   sessionId?: entityId;
   relatedBookingInterests?: IRelatedBookingInterestUpdate[];
}

export interface AllocationBookingInterestInterface {
   email?: string | null;
   bookingInterestId?: number | null;
   relationShipToInvitee?: string | null;
   allocationSessionId?: number | null;
   assignedFirstName?: string | null;
   assignedLastName?: string | null;
   AdditionalGuestsNumber?: string | null;
}

export interface BookingInterestInfoInterface {
   session: SessionInterface;
   show: ShowInterface;
 }

 export interface BulkCsvAddBookingInterestsInterface {
   sessionId: number;
   allocationId: number;
   bookingInterestCsv: any;
}

export interface BookingInterestUser {
  id?: string;
  firstName: string;
  lastName: string;
  phoneNumber?: string;
  email: string;
  age?:  number;
  accessibility?:  string | null;
  otherAccessibility?:  string | null;
}

export class UserBookingInterest {
  allocationSession?: BookingInterestAllocationSessionInterface;
  id?: number;
  status!: keyof typeof BookingInterestStatus;
  assignedFirstName?: string;
  assignedLastName?: string;
  user!: BookingInterestUser;
  session!: BookingInterestSessionInterface;
  ticket!: TicketInterface | null;
  parentId?: number | null;
  allocationSessionId?: number | null;
  isDependent?: boolean;
  invitedToTicketExpiration?: string;
  relatedBookingInterests?: UserBookingInterestsInterface;
  parentAndSiblingInterests?: UserBookingInterestsInterface;
  accessibility?: string;
  otherAccessibility?: string;
  accessibilityRequestStatus?: "Accepted" | "Pending";
  lastMinute?: boolean;
  userAgeAtBooking?: number;

  constructor(data: Partial<UserBookingInterest>) {
    Object.assign(this, data);
    if (data.relatedBookingInterests) {
      this.relatedBookingInterests = data.relatedBookingInterests.map(
        (item) => new UserBookingInterest(item)
      );
    }
  }

  get hasAccessibilityRequirements(): boolean {
    return !!this.accessibility?.trim() || !!this.otherAccessibility?.trim();
  }
}

 export interface BookingInterestAccessibilityRequestInterface {
   bookingInterestId: number;
   leadBookerId: string;
   fullName: string;
   email: string;
   sessionId: number;
   sessionName: string;
   status: string;
   accesiblityRequirements: string;
   numberOfPeople: number;
   accessibilityRequestStatus: string;
   allocationName: string | null;
   allocationType: string | null;
 }

 export interface BookingInterestMinAgeOverrideRequestInterface {
   bookingInterestId: number;
   leadBookerId: string;
   fullName: string;
   email: string;
   sessionId: number;
   sessionName: string;
   status: string;
   accesiblityRequirements: string;
   numberOfPeople: number;
 }

 export interface BookingInterestAllocationSessionInterface {
   allocation: BookingInterestAllocationInterface;
   allocationId: number;
   id: number;
 }

 export interface BookingInterestAllocationInterface {
   name: string;
   type: AllocationType;
 }

 export type BookingInterestInfo = BookingInterestInfoInterface | null;
 export type UserBookingInterestsInterface = UserBookingInterest[] | null;
 export type BookingInterestsAccessibilityRequestInterface = BookingInterestAccessibilityRequestInterface[] | null;
 export type BookingInterestsMinAgeOverrideRequestInterface = BookingInterestMinAgeOverrideRequestInterface[] | null;
 export type BookingInterestAllocation = BookingInterestAllocationSessionInterface | null;
